import { lazy } from 'react'

export const Result = lazy(() => import('./v1/Result'))
